import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Dropzone from 'react-dropzone';
import ResourceContainer from '../../containers/Resource';
import { withStyles } from '@material-ui/core/styles/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import { showErrors } from '../../modules/general';
import CheckIcon from '@material-ui/icons/CheckCircle';
import uploadToCloudIcon from '../../images/uploadToCloud.svg';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';

const styles = () => {
	return {
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		check: {
			color: '#4CAF50',
			width: 40,
			height: 40,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
		dragDrop: {
			fontFamily: 'Roboto-Bold',
			fontSize: 16,
			color: '#2F8ECB',
			letterSpacing: 0,
			textAlign: 'center',
		},
		uploadIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 53,
			height: 52,
			backgroundImage: `url('${uploadToCloudIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
		},
		isUploading: {
			fontSize: 20,
			fontWeight: 900,
			letterSpacing: '-1px',
			position: 'absolute',
			width: '100%',
			height: '100%',
			backgroundColor: 'rgba(255, 255, 255, .9)',
			top: 0,
			left: 0,
			textAlign: 'center',
			border: '2px solid #2F8ECB',
			borderRadius: '4px',
			display: 'flex',
			alignItems: 'center',
			justifyItems: 'center',
			justifyContent: 'center',
		},
		isShowingSuccess: {
			border: '2px solid #4CAF50',
		},
	};
};

class ResourceUploader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isReadyForUpload: true,
			isUploading: false,
			isShowingSuccess: false,
			files: [],
		};
	}

	onDrop = (files) => {
		//- Set state uploading
		const {
			addResource,
			name,
			onlyOne,
			onUpload,
			afterUpload,
			serviceName,
			stayOnSuccessAfterUpload,
		} = this.props;

		this.setState({
			isReadyForUpload: false,
			isUploading: true,
		});
		if (onUpload) {
			onUpload({ data: files[0] });
		}

		addResource({
			serviceName,
			params: {},
			files: [
				{
					name: 'file',
					data: files[0],
				},
			],
			callback: (err, r) => {
				const resource = _.get(r, ['collections', 'resourceCollection', 0]);

				if (!resource) {
					showErrors(['Problems uploading file. Sorry.']);
					return;
				}

				this.setState({
					isUploading: false,
					isShowingSuccess: true,
				});

				setTimeout(() => {
					let isShowingSuccess = !!stayOnSuccessAfterUpload;
					this.setState({
						isShowingSuccess,
						isReadyForUpload: !onlyOne,
					});

					afterUpload({
						name,
						resource,
					});
				}, 500);
			},
		});
	};

	render() {
		const { classes, customProgress } = this.props;
		const {
			//isReadyForUpload,
			isUploading,
			isShowingSuccess,
		} = this.state;

		return (
			<Fragment>
				<FormControl className={classes.formControl}>
					<div className="dropzone" style={{ position: 'relative' }}>
						<Dropzone onDrop={this.onDrop}>
							{({ getRootProps, getInputProps, isDragActive }) => {
								return (
									<div
										{...getRootProps()}
										className={classNames('dropzone', { 'dropzone--isActive': isDragActive })}
										style={{
											//height : 100,
											width: '100%',
											textAlign: 'center',
											backgroundColor: '#f1f1f1',
											borderWidth: 5,
											borderColor: '#bbbbbb',
											borderStyle: 'dashed',
											borderRadius: 10,
											cursor: 'pointer',
											position: 'relative',
											boxSizing: 'border-box',
											padding: 20,
										}}
									>
										<input {...getInputProps()} />
										<div className={classes.uploadIcon} />
										<p className={classes.dragDrop}>
											Drag N’ Drop
											<br />
											to upload your files
										</p>
										<Button variant="outlined" onClick={this.handleEdit} color="primary">
											or click to browse
										</Button>
									</div>
								);
							}}
						</Dropzone>

						{isUploading && (
							<div className={classes.isUploading}>
								<CircularProgress />
								<span style={{ marginLeft: 5 }}>Uploading...</span>
							</div>
						)}

						{customProgress && (
							<div className={classes.isUploading}>
								<CircularProgress />
								<span style={{ marginLeft: 5 }}>{customProgress}</span>
							</div>
						)}

						{isShowingSuccess && (
							<div className={`${classes.isUploading} ${classes.isShowingSuccess}`}>
								<span>
									<CheckIcon className={classes.check} />
								</span>
								Upload successful
							</div>
						)}
					</div>
				</FormControl>
			</Fragment>
		);
	}
}

ResourceUploader.propTypes = {
	serviceName: PropTypes.string,
	name: PropTypes.string.isRequired,
	onUpload: PropTypes.func,
	afterUpload: PropTypes.func,
	addResource: PropTypes.func.isRequired,
	showErrors: PropTypes.func,
	resource: PropTypes.object,
	classes: PropTypes.object.isRequired,
	onlyOne: PropTypes.bool,
	customProgress: PropTypes.string,
	stayOnSuccessAfterUpload: PropTypes.bool,
};

export default _.flow([withStyles(styles), ResourceContainer])(ResourceUploader);
